(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-card-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Guard: the bundle may be evaluated once, but sections can be re-rendered in the editor
    if (window.AWNLCardGrid) return;

    var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');

    function setState(card, open) {
      card.classList.toggle('is-active', open);
      var toggle = card.querySelector('.acg-card__toggle');
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeAll(except) {
      document.querySelectorAll('.acg-card--reveal.is-active').forEach(function (card) {
        if (card !== except) setState(card, false);
      });
    }

    // One delegated listener for every grid on the page (works after editor re-renders too)
    document.addEventListener('click', function (event) {
      var toggle = event.target.closest('.acg-card__toggle');

      // Click outside any reveal card closes open ones
      if (!toggle) {
        if (!event.target.closest('.acg-card--reveal')) closeAll(null);
        return;
      }

      // Mouse users get the hover effect; ignore mouse clicks so state doesn't "stick".
      // event.detail === 0 means keyboard (Enter / Space), which should still toggle.
      if (finePointer.matches && event.detail !== 0) return;

      var card = toggle.closest('.acg-card');
      var open = !card.classList.contains('is-active');
      closeAll(card);
      setState(card, open);
    });

    // Escape closes the open card and returns focus to its toggle
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var card = event.target.closest && event.target.closest('.acg-card--reveal.is-active');
      if (!card) return;
      setState(card, false);
      card.querySelector('.acg-card__toggle').focus();
    });

    // Theme editor: selecting a block reveals its text so it can be previewed / edited
    document.addEventListener('shopify:block:select', function (event) {
      var card = event.target;
      if (!card.classList || !card.classList.contains('acg-card')) return;
      if (card.classList.contains('acg-card--reveal')) {
        closeAll(card);
        setState(card, true);
      }
      card.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    });

    document.addEventListener('shopify:block:deselect', function (event) {
      var card = event.target;
      if (card.classList && card.classList.contains('acg-card--reveal')) setState(card, false);
    });

    window.AWNLCardGrid = true;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-scroll-stack-banner"] && !Shopify.designMode) return;
  try {
    
(function () {
  var section = document.getElementById('section-{{ section.id }}');
  if (!section) return;

  var videos = section.querySelectorAll('video[autoplay]');
  if (!videos.length) return;

  /* Pause all autoplay videos initially — let observer handle playback */
  videos.forEach(function (v) { v.pause(); });

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target.querySelector('video');
        if (!video) return;
        if (entry.isIntersecting) {
          video.play().catch(function () {
            /* Autoplay blocked — silently ignore */
          });
        } else {
          video.pause();
        }
      });
    },
    { threshold: 0.25 }
  );

  videos.forEach(function (video) {
    var slide = video.closest('.scroll-stack-banner__slide');
    if (slide) observer.observe(slide);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
